<template>
    <framework>
        <template #side>
            <side-panel-nav/>
        </template>

        <template #main>
            <main-header title="Online Course Catalog" icon="fa-browsers"/>

            <b-message type="is-warning" class="mt-6">
                <div class="columns is-gapless mt-4">
                    <div class="column is-narrow"><i class="fas fa-exclamation-triangle fa-fw mr-3 has-text-warning"></i></div>
                    <div class="column">
                        <div class="is-size-6 has-text-weight-bold">Looking for Washington State Professional Development Courses for Clock Hours?</div>

                        <div class="is-size-6 mt-3">We are upgrading the my247ed.com site. If you’re looking for your course enrollments or the legacy course catalog, please visit the legacy site button below to access your courses as usual. If you have any questions feel free to contact us at <a href="mailto:support@my247ed.com">support@my247ed.com</a>.</div>
                        <div class="mb-4 mt-5">
                            <b-button tag="a" type="is-primary" :href="'https://www.my247ed.com/account/doAppLogin.php?u=' + currentUser.email + '&h=' + currentUser.legacy_hash">Visit Legacy Site<i class="fad fa-arrow-up-right-from-square ml-3"></i></b-button>
                        </div>
                    </div>
                </div>
            </b-message>

            <div class="columns mt-6 is-block-touch is-block-widescreen is-block-desktop is-flex-fullhd">
                <div class="column is-8-fullhd course-tabs">

                    <b-tabs v-model="activeTab">
                        <b-tab-item>
                            <template #header><i class="fad fa-diagram-cells mr-3"></i>Browse Courses</template>

                            <div class="mt-5">
                                <div class="has-text-white" v-if="loading"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading courses...</div>
                                <div v-else>
                                    <b-button type="is-light" outlined class="mb-6" v-if="courseFilter" @click="courseFilter=null"><i class="fas fa-arrow-left mr-3"></i>Show all courses</b-button>
                                    <catalog-course
                                        class="mb-5"
                                        :course="course"
                                        v-for="course in sortedCourses"
                                        @enroll="enroll"
                                        :details="(courseFilter && course.id === courseFilter)"
                                        v-if="!courseFilter || (courseFilter && course.id === courseFilter)"
                                    />
                                </div>
                            </div>

                        </b-tab-item>

                        <b-tab-item>
                            <template #header><i class="fad fa-file-certificate mr-3"></i>Browse by Certification</template>

                            <div class="mt-5">
                                <div class="has-text-white" v-if="loading"><i class="fas fa-spin fa-spinner fa-fw mr-3"></i>Please wait. Loading certifications...</div>
                                <div v-else>
                                    <b-button type="is-light" outlined class="mb-6" v-if="certFilter" @click="certFilter=null"><i class="fas fa-arrow-left mr-3"></i>Show all certifications</b-button>
                                    <catalog-cert
                                        class="mb-5"
                                        :cert="cert" v-for="cert in certs"
                                        @course="course"
                                        :details="(certFilter && cert.id === certFilter)"
                                        v-if="!certFilter || (certFilter && cert.id === certFilter)"
                                    />
                                </div>
                            </div>
                        </b-tab-item>
                    </b-tabs>

                </div>
                <div class="column is-offset-1-fullhd has-text-white">
                    <hr class="is-hidden-fullhd"/>
                    <div class="">
                        <div class="mb-6">
                            <router-link :to="{name: 'enrollments'}">
                                <b-button type="is-light" outlined><i class="fad fa-chalkboard-teacher mr-3"></i>View Your Enrollments</b-button>
                            </router-link>
                        </div>

                        <div class="mt-6 mb-6 quick">
                            <h5 class="has-text-white mb-3 is-size-6 has-text-weight-bold"><i class="far fa-fw fa-chalkboard-user mr-3"></i>Access a Training Course</h5>
                            <b-field class="ml-4 pl-4">
                                <b-input placeholder="Course Access Code" v-model="trainingCode" expanded v-on:keyup.native.enter="trainingCheck"></b-input>
                                <p class="control">
                                    <b-button type="is-primary is-light" :disabled="!trainingCode" @click="trainingCheck">
                                        <i class="far fa-arrow-right"></i>
                                    </b-button>
                                </p>
                            </b-field>
                        </div>

                        <!-- Dynamic Category Filter -->
                        <category-filter
                            :certification-id="defaultCertificationId"
                            @filter-changed="onCategoryFilterChanged"
                        />
                        <div class="mb-5" @click="showCerts=!showCerts;"><span class="clickable"><i class="fas mr-4" :class="{'fa-plus-square': !showCerts, 'fa-minus-square': showCerts}"></i><span class="has-text-weight-bold">Certifications/Organizations</span></span></div>
                        <div class="ml-5 pl-2 mb-5" v-if="showCerts">
                            <b-field>
                                <b-switch size="is-small" :value="true">Washington State Professional Development</b-switch>
                            </b-field>
                            <b-field>
                                <b-switch size="is-small" :value="true">Washington Interscholastic Activities Association (WIAA)</b-switch>
                            </b-field>
                            <div class="ml-5 mt-5">
                                <b-button size="is-small" type="is-primary" class="ml-4"><i class="fas fa-gears mr-2"></i>Manage Certifications</b-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

            <b-modal v-model="enrollNotify" :width="500" scroll="keep" custom-class="notifyModal">
                <div class="card" v-if="enrollCourse">
                    <div class="card-content">
                        <div class="columns is-gapless">
                            <div class="column is-narrow mr-2">
                                <i class="fas fa-check-circle mr-3 fa-2x has-text-primary"></i>
                            </div>
                            <div class="column mr-3 content">
                                <div style="font-size: 0.8rem; padding: 0.1rem 0 0.3rem">ENROLLMENT COMPLETE</div>
                                <h4 class="has-text-primary">{{ enrollCourse.title }}</h4>

                                <ul class="model-menu">
                                    <li>
                                        <router-link v-if="enrollCourse.new_course" :to="'/course/' + enrollCourse.enroll_id"><i class="fad fa-pen-to-square mr-3 has-text-primary"></i>Open Course<i class="fas fa-arrow-right mr-4 is-pulled-right mt-1"></i></router-link>
                                        <router-link v-else :to="'/legacy/' + enrollCourse.enroll_id"><i class="fad fa-pen-to-square mr-3 has-text-primary"></i>Open Course<i class="fas fa-arrow-right mr-4 is-pulled-right mt-1"></i></router-link>
                                    </li>
                                    <li><a href v-on:click.prevent="enrollNotify=false"><i class="fad fa-browser mr-3 has-text-primary"></i>Continue Browsing Catalog<i class="fas fa-arrow-right mr-4 is-pulled-right mt-1"></i></a></li>
                                    <li>
                                        <router-link to="/enrollments"><i class="fad fa-chalkboard-teacher mr-3 has-text-primary"></i>See Your Course Enrollments<i class="fas fa-arrow-right mr-4 is-pulled-right mt-1"></i></router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>

                </div>
            </b-modal>
        </template>
    </framework>
</template>

<script>
    import MainHeader from "../../components/framework/MainHeader";
    import Framework from "../../components/framework/Framework";
    import SidePanelNav from "../../components/framework/SidePanelNav";
    import {client as http} from "../../http_client";
    import CatalogCourse from "../../components/CatalogCourse";
    import async from "async";
    import CatalogCert from "../../components/CatalogCert";
    import CategoryFilter from "../../components/course/CategoryFilter";
    import {mapActions, mapGetters} from "vuex";

    export default {
        components: {CatalogCert, CatalogCourse, CategoryFilter, Framework, SidePanelNav, MainHeader},
        data: function() {
            return {
                loading: true,
                courses: [],
                showCerts: true,
                certs: null,
                courseFilter: null,
                certFilter: null,
                activeTab: 0,
                enrollNotify: false,
                enrollCourse: null,
                trainingCode: ''
            };
        },
        computed: {
            ...mapGetters(['enrollments', 'currentUser', 'selectedCategories', 'selectedCategoryIds']),
            sortedCourses() {
                let filtered = this.courses;

                // Apply category filter if any categories are selected
                if (this.selectedCategoryIds && this.selectedCategoryIds.length > 0) {
                    filtered = filtered.filter(course => {
                        if (!course.categories || course.categories.length === 0) {
                            return false;
                        }
                        // Check if course has any of the selected categories
                        return course.categories.some(cat =>
                            this.selectedCategoryIds.includes(cat.id)
                        );
                    });
                }

                return filtered.sort((a, b) => (a.title.toUpperCase() > b.title.toUpperCase()) ? 1 : -1);
            },
            // Default certification ID for category filter (could be made dynamic)
            defaultCertificationId() {
                // Return the first certification ID if certs are loaded
                if (this.certs && this.certs.length > 0) {
                    return this.certs[0].certification_id || this.certs[0].id;
                }
                return null;
            }
        },
        methods: {
            ...mapActions(['getEnrollments', 'getCategories']),
            onCategoryFilterChanged(selectedCategories) {
                // The filtering is done in computed property sortedCourses
                // This method can be used for analytics or additional actions
                console.log('Category filter changed:', selectedCategories.map(c => c.title));
            },
            load: function() {

                http.get('app/certs/', {force: true}).then(response => {
                    this.certs = response.data;
                });

                async.series([
                    (cb) => {
                        if (!this.enrollments) {
                            this.getEnrollments().then(() => {
                                cb();
                            });
                        } else {
                            cb();
                        }
                    },
                    (cb) => {
                        http.get('app/courses/new').then(response => {
                            for (let i = 0; i < response.data.length; i++) {
                                const course = response.data[i];
                                course.processing = false;

                                // console.log(this.enrollments);

                                for (let j = 0; j < this.enrollments.length; j++) {
                                    const enrollment = this.enrollments[j];
                                    if (course.id === enrollment.courses.id) {
                                        course.enrolled = true;
                                        break;
                                    }
                                }
                            }

                            this.courses = response.data;
                            cb();
                        });
                    },
                    (cb) => {
                        if (this.$route.query.code) {
                            this.trainingCode = this.$route.query.code;
                            this.trainingCheck();
                        }
                        cb();
                    }
                ], err => {
                    this.loading = false;
                });

                if (this.$route.query.course) {
                    this.activeTab = 0;
                    this.courseFilter = parseInt(this.$route.query.course);
                }

                if (this.$route.query.cert) {
                    this.activeTab = 1;
                    this.certFilter = parseInt(this.$route.query.cert);
                }
            },
            enroll: function(course) {
                this.$router.push({name: 'course-enroll', params: {courseId: course.id}});
            },
            isEnrolled(course) {
                for (let i = 0; i < this.enrollments.length; i++) {
                    const enrollment = this.enrollments[i];
                    if (course.id === enrollment.courses.id) {
                        return true;
                    }
                }
            },
            course: function(id) {
                if (parseInt(this.$route.query.course) !== id) {
                    this.$router.push({path: 'course-catalog', query: {course: id}});
                } else {
                    this.activeTab = 0;
                    this.courseFilter = id;
                }
            },
            trainingCheck: function() {
                http.get('app/courses/new/code/' + this.trainingCode, {force: true}).then(response => {
                    let course = response.data;
                    for (let j = 0; j < this.enrollments.length; j++) {
                        const enrollment = this.enrollments[j];
                        if (course.id === enrollment.course_id) {
                            course.enrolled = true;
                            break;
                        }
                    }

                    let found = false;
                    for (let i = 0; i < this.courses.length; i++) {
                        const c = this.courses[i];
                        if (c.id === course.id) {
                            found = true;
                            break;
                        }
                    }

                    if (!found) {
                        this.courses.push(course);
                        this.course(course.id);
                    }
                }).catch(err => {
                    console.log(err);
                    if (err.response.status === 404) {
                        this.$notify('error', 'Training', 'Invalid Training Code.  Please check the code and try again. Please note this is not a search field.', {duration: 5000, permanent: false});
                    } else {
                        window.alert('An error occurred.  If you need additional help please contact us at support@my247ed.com.');
                    }
                });
                this.trainingCode = '';

            }
        },
        watch: {
            '$route.query.course'() {
                console.log('Changing course search');
                this.activeTab = 0;
                this.courseFilter = parseInt(this.$route.query.course);
            }
        },
        mounted: function() {
            this.load();
        }
    };
</script>

<style lang="scss" scoped>
    .options {
        position: relative;
        width: 360px;
        transition: width 100ms;

        padding-top: 3.8rem;

        .sub-header {
            font-weight: bold !important;
            cursor: default !important;
            color: #4a4a4a !important;
            padding: 0.5rem 2rem 0.3rem !important;
            font-size: 0.8rem !important;
            text-transform: uppercase;
            background-color: #f3f3f5 !important;
        }

        section {
            padding: 1rem 2rem;

            .field {
                margin: 3px;
            }
        }
    }

    .clickable {
        cursor: pointer !important;
    }
</style>

<style lang="scss">
    .course-tabs {
        .tabs {
            color: white;

            li a {
                color: #9faec2 !important;
                font-size: 0.9rem;

                &:hover {
                    border-bottom-color: #6f8295;
                }
            }

            li.is-active a {
                color: #ffffff !important;
                border-bottom-color: #6f8295;
                font-size: 0.9rem;

            }
        }

        .tab-content {
            padding: 1rem 0 0 !important;
        }
    }

    .notifyModal {
        z-index: 120;

        ul.model-menu {
            list-style: none;
            margin: 0 0 0 -0.75rem;
            padding: 0;

            li {
                margin: 0;
                padding: 0.2rem 0;
                border-top: 1px solid #eee;
                font-weight: bold;

                &:first-child {
                    border: none;
                }

                > a {
                    display: block;
                    color: #333;
                    padding: 0.5rem 0 0.5rem 0.8rem;

                    &:hover {
                        cursor: pointer;
                        border-radius: 5px;
                        background-color: #336699;
                        color: #ffffff !important;

                        i {
                            color: white !important;
                        }
                    }
                }
            }
        }
    }
</style>
